export { default } from './timer-2'
